import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LeadsProvider } from './contexts/LeadsContext';
import { VehiclesProvider } from './contexts/VehiclesContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { WhatsAppFab } from './components/WhatsAppFab';
import { ScrollToTop } from './components/ScrollToTop';
import { PixelTracker } from './components/PixelTracker';
import { Home } from './pages/Home';
import { Catalogo } from './pages/Catalogo';
import { VehicleDetail } from './pages/VehicleDetail';
import { Financiacion } from './pages/Financiacion';
import { SimulacionCredito } from './pages/SimulacionCredito';
import { FinanciarUsado } from './pages/FinanciarUsado';
import { VenderAuto } from './pages/VenderAuto';
import { Permutas } from './pages/Permutas';
import { Contacto } from './pages/Contacto';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="23u9v6r043jyv">
      <LeadsProvider data-id="element-1" data-mp="23utadzydnu97">
        <VehiclesProvider data-id="element-2" data-mp="23ti8k5ohswkq">
          <div className="flex min-h-screen w-full flex-col bg-ink" data-id="element-3" data-mp="3ikh8gaq64uzi">
            <ScrollToTop data-id="element-4" data-mp="3ii4su47vuwpm" />
            <PixelTracker data-id="element-5" data-mp="3mlatmwc87vop" />
            <Header data-id="element-6" data-mp="3mkhou0wtvg97" />
            <div className="flex-1" data-id="element-7" data-mp="3mjq1tehaqquj">
              <Routes data-id="element-8" data-mp="3rcj6618urx63">
                <Route path="/" element={<Home data-id="element-10" data-mp="3rcsxpt9jqcdw" />} data-id="element-9" data-mp="3rbzo8kj7d8s2" />
                <Route path="/catalogo" element={<Catalogo data-id="element-12" data-mp="6hrlipoilfp" />} data-id="element-11" data-mp="3recc1ebn6dd1" />
                <Route path="/vehiculos/:slug" element={<VehicleDetail data-id="element-14" data-mp="7st1bvnjh3n" />} data-id="element-13" data-mp="4n6a3ahwrb3" />
                <Route path="/financiacion" element={<Financiacion data-id="element-16" data-mp="2zmwif0bo3qdb" />} data-id="element-15" data-mp="2zlv6yuqqp1v2" />
                <Route path="/simulacion-credito" element={<SimulacionCredito data-id="element-18" data-mp="33orki71fa7s5" />} data-id="element-17" data-mp="33mowfsjtyoq2" />
                <Route path="/financiar-usado" element={<FinanciarUsado data-id="element-20" data-mp="38nuqbtp88i16" />} data-id="element-19" data-mp="38kqb81a841vq" />
                <Route path="/vender-mi-auto" element={<VenderAuto data-id="element-22" data-mp="3dmfqxu8e53q5" />} data-id="element-21" data-mp="3dle28mygcipy" />
                <Route path="/permutas" element={<Permutas data-id="element-24" data-mp="nwc2huqftzxb" />} data-id="element-23" data-mp="3dii694660445" />
                <Route path="/contacto" element={<Contacto data-id="element-26" data-mp="nxwv3et6z8sj" />} data-id="element-25" data-mp="nv0ypuwzss67" />
                <Route path="*" element={<Home data-id="element-28" data-mp="stc7e2bjwwmu" />} data-id="element-27" data-mp="su427axbqqc2" />
              </Routes>
            </div>
            <Footer data-id="element-29" data-mp="35ypel6klo1z" />
            <WhatsAppFab data-id="element-30" data-mp="35gm54lhq9kk" />
          </div>
        </VehiclesProvider>
      </LeadsProvider>
    </BrowserRouter>;
}